import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useUserService } from '@climate/components'

export default function Logout() {
  const navigate = useNavigate()
  const { _logout } = useUserService(window.config.iam_service_url, window.config.session_cookie, 'iam')

  useEffect(() => {
    const run = async () => {
      await _logout()
      const redirectUrl = new URLSearchParams(window.location.search).get('redirect_url')
      navigate(
        redirectUrl ? `/app/login?redirect_url=${encodeURIComponent(redirectUrl)}` : '/app/login',
        { replace: true }
      )
    }
    run()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <></>
}
